(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rxk-uhr-farben"] && !Shopify.designMode) return;
  try {
    (() => {
    const zeigen = (knopf) => {
      const box = knopf.closest('[data-rxk-uf]');
      const bild = box.querySelector('.rxk-uf__bild');
      box.querySelectorAll('.ist-aktiv').forEach((k) => k.classList.remove('ist-aktiv'));
      knopf.classList.add('ist-aktiv');
      // erste Farbe = Kartenbild selbst; Farben ohne eigenes Foto ändern das Bild nicht
      if (knopf.dataset.bild) { bild.src = knopf.dataset.bild; bild.hidden = false; }
      else if (knopf === box.querySelector('.rxk-uf__farbe')) bild.hidden = true;
    };
    document.addEventListener('mouseover', (e) => {
      const k = e.target.closest?.('.rxk-uf__farbe');
      if (k) zeigen(k);
    });
    document.addEventListener('click', (e) => {
      const k = e.target.closest?.('.rxk-uf__farbe');
      if (!k) return;
      e.preventDefault();
      e.stopPropagation();
      zeigen(k);
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rxk-zuschnitt"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    // Werte, die in der Modellauswahl gerade gewaehlt sind (Knoepfe oder Dropdown).
    // Bewusst ohne Optionsnamen: der heisst je Sprache anders (Modell/Model/…).
    function gewaehlteWerte() {
      var werte = [];
      document.querySelectorAll('variant-picker input[type="radio"]:checked, variant-picker select').forEach(function (el) {
        if (el.value) werte.push(el.value);
      });
      return werte;
    }

    function hervorheben(box) {
      var werte = gewaehlteWerte();
      var treffer = null;
      box.querySelectorAll('.rxk-zs-gruppe').forEach(function (g) {
        var modelle = (g.getAttribute('data-modelle') || '').split('|');
        var aktiv = werte.some(function (w) { return modelle.indexOf(w) !== -1; });
        g.classList.toggle('ist-aktiv', aktiv);
        if (aktiv && !treffer) treffer = g;
      });
      box.classList.toggle('ist-gewaehlt', !!treffer);
      // Mobil ist die Zeichnung breiter als der Bildschirm: gewaehlte Spalte in die Mitte
      if (treffer && box.scrollWidth > box.clientWidth) {
        var r = treffer.getBoundingClientRect(), b = box.getBoundingClientRect();
        box.scrollLeft += r.left + r.width / 2 - (b.left + b.width / 2);
      }
    }

    // Eine Datei wird nur einmal geholt, Dialog und Tab teilen sich das Ergebnis.
    var cache = {};
    function holeSvg(url) {
      if (!cache[url]) {
        cache[url] = fetch(url)
          .then(function (r) { if (!r.ok) throw r.status; return r.text(); })
          .then(function (text) {
            var svg = new DOMParser().parseFromString(text, 'image/svg+xml').documentElement;
            if (!svg || svg.nodeName.toLowerCase() !== 'svg') throw 'keine svg';
            // Keine Skripte aus der Datei uebernehmen
            svg.querySelectorAll('script, foreignObject').forEach(function (el) { el.remove(); });
            return svg;
          });
      }
      return cache[url];
    }

    function laden(box) {
      if (box.getAttribute('data-geladen')) return Promise.resolve();
      box.setAttribute('data-geladen', '1');
      return holeSvg(box.getAttribute('data-rxk-zs-src'))
        .then(function (svg) {
          var neu = document.importNode(svg, true);
          var img = box.querySelector('img');
          if (img) neu.setAttribute('aria-label', img.alt);
          box.replaceChildren(neu);
        })
        .catch(function () { /* <img> bleibt stehen */ });
    }

    // Umrisse je Gruppe (ohne Beschriftung) vermessen. getBBox braucht ein
    // gerendertes Element — der Tab ist aber oft zugeklappt. Deshalb einmal
    // unsichtbar ausserhalb des Bildschirms einsetzen, messen, entfernen.
    var masse = {};
    function vermessen(url, svg) {
      if (masse[url]) return masse[url];
      var probe = document.importNode(svg, true);
      probe.setAttribute('style', 'position:absolute;left:-10000px;top:0;width:1000px;visibility:hidden');
      document.body.appendChild(probe);
      var gruppen = [];
      probe.querySelectorAll('.rxk-zs-gruppe').forEach(function (g) {
        var x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
        Array.prototype.forEach.call(g.children, function (el) {
          if (el.nodeName.toLowerCase() === 'text') return;
          var b = el.getBBox();
          x0 = Math.min(x0, b.x); y0 = Math.min(y0, b.y);
          x1 = Math.max(x1, b.x + b.width); y1 = Math.max(y1, b.y + b.height);
        });
        gruppen.push({ modelle: (g.getAttribute('data-modelle') || '').split('|'), box: [x0, y0, x1 - x0, y1 - y0] });
      });
      probe.remove();
      return (masse[url] = gruppen);
    }

    // Kleines SVG nur mit dem Umriss einer Gruppe
    function umriss(svg, index, box) {
      var ns = 'http://www.w3.org/2000/svg';
      var neu = document.createElementNS(ns, 'svg');
      var rand = 6;
      neu.setAttribute('viewBox', [box[0] - rand, box[1] - rand, box[2] + rand * 2, box[3] + rand * 2].join(' '));
      neu.setAttribute('aria-hidden', 'true');
      neu.setAttribute('focusable', 'false');
      var defs = svg.querySelector('defs');
      if (defs) neu.appendChild(document.importNode(defs, true));
      var g = svg.querySelectorAll('.rxk-zs-gruppe')[index];
      Array.prototype.forEach.call(g.children, function (el) {
        if (el.nodeName.toLowerCase() !== 'text') neu.appendChild(document.importNode(el, true));
      });
      return neu;
    }

    function tabAktualisieren(tab) {
      var url = tab.getAttribute('data-rxk-zs-src');
      holeSvg(url).then(function (svg) {
        var gruppen = vermessen(url, svg);
        var werte = gewaehlteWerte();
        var treffer = -1, modell = '';
        gruppen.forEach(function (g, i) {
          if (treffer !== -1) return;
          for (var k = 0; k < werte.length; k++) {
            if (g.modelle.indexOf(werte[k]) !== -1) { treffer = i; modell = werte[k]; return; }
          }
        });
        var mein = tab.querySelector('.rxk-zs-mein');
        if (treffer === -1) {
          mein.hidden = true;
          tab.classList.remove('ist-mein');
          return;
        }
        if (tab.getAttribute('data-gruppe') !== String(treffer)) {
          tab.setAttribute('data-gruppe', String(treffer));
          tab.querySelector('.rxk-zs-mein__bild').replaceChildren(umriss(svg, treffer, gruppen[treffer].box));
        }
        tab.querySelector('[data-rxk-zs-modell]').textContent = modell;
        var andere = gruppen[treffer].modelle.filter(function (m) { return m !== modell; });
        // Geschuetzte Leerzeichen: kein Umbruch mitten im Namen ("iPhone | 15 Plus")
        tab.querySelector('[data-rxk-zs-auch]').textContent = andere.map(function (m) { return m.replace(/ /g, ' '); }).join(' · ');
        tab.querySelector('[data-rxk-zs-auch-zeile]').hidden = andere.length === 0;
        mein.hidden = false;
        tab.classList.add('ist-mein');
      }).catch(function () { /* Gesamtvorschau bleibt */ });
    }

    function alleTabs() {
      document.querySelectorAll('.rxk-zs-tab').forEach(tabAktualisieren);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alleTabs);
    else alleTabs();

    // Modellwechsel: Horizon tauscht nur die Modellauswahl aus, der Tab bleibt stehen
    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest && event.target.closest('variant-picker')) alleTabs();
    });

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var opener = target.closest('[data-rxk-zs-open]');
      if (opener) {
        var dialog = document.getElementById(opener.getAttribute('data-rxk-zs-open'));
        if (!dialog || typeof dialog.showModal !== 'function') return; // Tab-Vorschau: Link oeffnet die Datei
        event.preventDefault();
        dialog.showModal();
        var box = dialog.querySelector('.rxk-zs__bild');
        laden(box).then(function () { hervorheben(box); });
        return;
      }

      if (target.closest('[data-rxk-zs-close]')) {
        var offen = target.closest('dialog');
        if (offen) offen.close();
        return;
      }

      // Klick auf die Flaeche neben der Karte schliesst
      if (target.classList && target.classList.contains('rxk-zs__dialog')) target.close();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    // ROXXLYN: "Weitere Modelle" klappt die kompakte Geraeteauswahl auf.
  // Bleibt offen, bis Horizon die Auswahl nach einem Wechsel neu rendert
  // (dann offen, wenn ein Modell ab Position 5 gewaehlt ist).
  document.addEventListener('click', function (event) {
    var knopf = event.target && event.target.closest ? event.target.closest('[data-rxk-mehr-knopf]') : null;
    if (!knopf) return;
    var feld = knopf.closest('.rxk-kompakt');
    if (!feld) return;
    feld.classList.add('ist-offen');
    knopf.setAttribute('aria-expanded', 'true');
    var erster = feld.querySelector('.rxk-mehr input');
    if (erster) erster.focus({ preventScroll: true });
  });

  // ROXXLYN (rxk-swatch-name): Name der gewaehlten Farbe sofort beim Tippen zeigen,
  // nicht erst nach der Server-Antwort (auf dem iPhone blieb er sonst stehen).
  document.addEventListener('change', function (event) {
    var feld = event.target && event.target.closest ? event.target.closest('.variant-option--swatches') : null;
    if (!feld || event.target.type !== 'radio') return;
    var anzeige = feld.querySelector('.variant-option__swatch-value');
    if (anzeige) anzeige.textContent = event.target.value;
  });
  } catch(e) { console.error(e); }
})();

})();
